import axios, {AxiosInstance} from "axios";
import {CateMenuAndOptionData, CateMenuListData, ShopTblData, UserData, Receipt, ReceiptRes} from "./model";
import {Order, OrderPlaceRes, OrderStatusRes, OrderSessionRes} from "./order_model";
import apps from "./apps";

let axiosInst: AxiosInstance;

export async function getShop(shopId: string, tableNo): Promise<ShopTblData>  {
  return getAxiosInst().get(`/shop/${shopId}/tbl/${tableNo}`).then(res => res.data)
}

export async function getCateMenuList(shopId: number): Promise<CateMenuListData[]> {
  return getAxiosInst().get(`/menu/shop/${shopId}`).then(res => res.data)
}

export async function getCateMenuAndOptionList(shopId: number, tblNo: String): Promise<CateMenuAndOptionData> {
  return getAxiosInst().get(`/menu/shop/${shopId}/tbl/${tblNo}/withoption`).then(res => res.data)
}

export async function placeOrder(order: Order): Promise<OrderPlaceRes> {

  return getAxiosInst().post("/order/place", order).then(res => res.data)
}

export function getOrderStatus(orderId: number): Promise<OrderStatusRes> {
  if (orderId === 0) {
    return Promise.reject(); // Prevents API call
  }

  return getAxiosInst().get(`/order/status/${orderId}`).then(res => {
    const data: OrderStatusRes = res.data;

    console.log(data);

    if (data.orderStatus == "FAILED" || data.orderStatus == "CONFIRMED" || data.orderStatus == "WAITING_PAYMENT" || data.orderStatus == "CANCELED") {
        return data;
    }

    throw new Error("There was an error with our system. Try checking out one more time.");
  })
}

/** 테이블 세션 주문목록 다시보기. 서버가 orderId로 txId를 해석해 같은 세션 주문들을 반환. */
export function getOrderSession(shopId: string, orderId: number): Promise<OrderSessionRes> {
  return getAxiosInst().get(`/order/session/${shopId}/${orderId}`).then(res => res.data);
}

export async function findUser(uuid: string): Promise<UserData> {
  return getAxiosInst().post(`/user/uuid/${uuid}`).then(res => {
    const data: UserData = res.data;

    console.log(data);

    if (data.status != "ACTIVE") {
      throw new Error("Invalid User status " + data.status);
    }

    return data;
  })
}

export async function saveReceipt(receipt: Receipt): Promise<ReceiptRes> {

  return getAxiosInst().post("/receipt/create", receipt).then(res => res.data)
}

export async function cancelOrder(orderId: number): Promise<OrderStatusRes> {

  return getAxiosInst().post(`/order/cancel/${orderId}`, orderId).then(res => res.data)
}

export async function findReceiptByOrderId(orderId: number): Promise<Receipt> {

  return getAxiosInst().get(`/receipt/findByOrderId/${orderId}`).then(res => res.data)
}


/** QR Call Staff: 다인인 손님이 직원 호출. 서버가 shop.callStaff·qrType(TB*)·tblNo 검증 후 staff_call 생성. */
export async function staffCall(shopId: string, tblNo: string, qrType: string): Promise<{ ok: boolean; message?: string }> {
  return getAxiosInst().post(`/staffcall`, { shopId, tblNo, qrType }).then(res => res.data)
}

/** Till CNP 결제 세션 개시. 금액은 서버가 orderId로 계산 — 앱은 절대 금액을 보내지 않는다. */
export async function createPaymentSession(shopId: number, orderId: number): Promise<{ redirectUrl: string | null, error: string | null }> {
  return getAxiosInst().post(`/payment/session`, { shopId, orderId }).then(res => res.data)
}

/** Till CNP 결제 세션 상태 조회(Task 13 폴링용). */
export async function getPaymentStatus(shopId: number, orderId: number): Promise<{ status: "PENDING" | "PAID" | "FAILED" | "NONE" | "ABANDONED" }> {
  return getAxiosInst().get(`/payment/session/${shopId}/${orderId}`).then(res => res.data)
}

// 앱이 실제로 호출하는 API 호스트(=Till 반환 페이지가 뜨는 오리진)를 한 곳에서 계산한다.
// getAxiosInst와 checkout.tsx의 postMessage origin 검증이 서로 다른 값을 쓰면 안 되기 때문에 공유.
function resolveApiHost(): string {
  if (__DEV__) {
    // 앱을 로드한 브라우저의 호스트명을 그대로 API 호스트로 사용한다. 개발 PC에서 localhost로 열면
    // localhost, LAN IP(예: 192.168.5.41)로 열면 그 IP → 같은 wifi의 다른 기기에서도 그대로 접속됨.
    // (API 서버 :8090이 Expo 웹을 띄운 같은 PC에 있다는 전제.) window 없으면 localhost 폴백.
    const devHostname = (typeof window !== "undefined" && window.location && window.location.hostname)
      ? window.location.hostname : "localhost";
    return `http://${devHostname}:8090`;
  }
  return apps.profile == "prod" ? "https://api.pikashop.com.au" : "https://dev-api.pikashop.com.au";
}

/** Till CNP 반환 페이지 postMessage의 기대 origin(=API 호스트 자체). 매 호출마다 apps.profile 기준으로 계산. */
export function getApiOrigin(): string {
  return resolveApiHost();
}

function getAxiosInst(host?: String) {
  if (axiosInst == null) {
    host = resolveApiHost();
    console.log(`Host: ${host}`);

    axiosInst = axios.create({
      baseURL: `${host}/api`,
      timeout: 30000,
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET, PUT, POST, DELETE, OPTIONS",
      }
    });
  }
  return axiosInst;
}
